// extracted by mini-css-extract-plugin
export default {"msgM":"dde36da276"};